export function isDisabled(array) {
  if (!array || !array.length) {
    return true;
  }
  return isAllDisabled(array);
}

export function isAllDisabled(array) {
  if (!array.length) return false;
  return array.find((item) => !item.disabled) ? false : true;
}

function getFirstHTMLPage(resources) {
  const getLength = (file) => file?.fileUrl && file.fileUrl.split("/").length;
  const otherPages = resources
    .filter((resource) => {
      if (!resource?.fileUrl) return false;
      return resource.fileUrl.endsWith("html");
    })
    .sort((a, b) => getLength(a) - getLength(b));
  return otherPages[0];
}


export function getModuleType(resources) {
  var result = { notFound: true };
  const modulesTypes = [
    ["html"],
    ["mp4", "mkv", "m4v"],
    ["ppt", "docx", "pdf", "pptx", "pps"],
    ["mp3"],
    // ['png', 'jpg', 'jpeg']
  ];
  var move = 0,
    lastStep = modulesTypes.length - 1;
  while (result.notFound) {
    result = findMainModuleFile(resources, modulesTypes[move], result);
    if (move === lastStep) break;
    move += 1;
  }

  //If many htmls then prioritize html file
  if (result.fileType === "html") {
    result.resource = getFirstHTMLPage(resources);
  }

  return result;
};

//Find the main module to be displayed
export function findMainModuleFile (resources, mainFileTypes, data) {
  for (let resource of resources) {
    const nameParts = resource.fileName ? resource.fileName.split(".") : "";
    const fileType = nameParts[nameParts.length - 1].toLowerCase();
    if (mainFileTypes.includes(fileType)) {
      data["notFound"] = false;
      data["resource"] = resource;
      data["fileType"] = fileType;
      break;
    }
  }
  return data;
};


export function fileType(type) {
    if (type === "png" || type === "jpg" || type === "jpeg" || type === "gif") {
      return "Image";
    } else if (type === "pdf") {
      return "PDFDocument";
    } else if (type === "txt") {
      return "Document";
    } else if (
      type === "mp4" ||
      type === "mkv" ||
      type === "webm" ||
      type === "m4v"
    ) {
      return "Video";
    } else if (type === "swf") {
      return "swfVideo";
    } else if (type === "ppt" || type === "pptx" || type === "pps") {
      return "PowerPoint";
    } else if (type === "html") {
      return "Activity";
    } else if (type === "mp3") {
      return "Audio";
    } else if (type === "docx" || type === "doc") {
      return "WordDocument";
    } else {
      return "Unsupported";
    }
  };

  //Function to decide the action to be executed based on the file type
export function actionType(name) {
    const type = fileType(name);
    console.log("FILE TYPE", type);
    if (type === "Video") {
      return "watch";
    } else if (type === "Image") {
      return "show";
    } else if (type === "PDFDocument") {
      return "pdfview";
    } else if (
      type === "Document" ||
      type === "PowerPoint" ||
      type === "WordDocument"
    ) {
      return "view";
    } else if (type === "swfVideo") {
      return "watchSWF";
    } else if (type === "Audio") {
      return "listen";
    } else if (type === "Activity") {
      return "link"
    }
  };
